import axios from 'axios';

/** Independent asset transport without API interceptors. Clear any bearer default inherited at creation. */
export const publicHttpClient = axios.create({ // nosemgrep: figma.weavy-no-raw-axios
  withCredentials: false,
  headers: { common: { Authorization: undefined } },
});
